<template>
    <div class="row" :style="{height: windowHeight - pageTopHeight - 60 + 'px'}">
        <div class="col-lg-12 col-md-12 col-sm-12">
        <!--General Top Bar -->
            <!-- <general-top-bar :title="$t('settingsPages.printers')"></general-top-bar> -->
            <!--End General Top Bar -->
            <div class="card mar-to-15">
                <div class="card-content">
                    <!-- <div class="pull-left mar-bt-20">
                        <el-input v-model="searchQuery" :placeholder="$t('reports.search')" class="icon-search"></el-input>
                    </div> -->
                    <div class="pull-right mar-bt-20">
                        <button class="btn add" @click.prevent="add" :title="$t('general.add')">
                            <img src="/static/img/icons/add.png">
                            {{$t('general.add')}}
                        </button>
                    </div>
                    <data-tables
                        v-loading="loading"
                        :data="data"
                        :current-page="pagination.currentPage"
                        :page-size="pagination.pageSize"
                        :table-props="{'border': false}"
                        style="width: 100%">

                        <el-table-column
                            min-width="20"
                            label="ID">
                            <template slot-scope="props">
                              {{ props.row.id }}
                            </template>
                        </el-table-column>

                        <el-table-column
                          min-width="40"
                          :label="$t('customers.name')">
                          <template slot-scope="props">
                            {{ props.row.name || "-" }}
                          </template>
                        </el-table-column>

                        <el-table-column
                            min-width="50"
                            prop="location.name"
                            :label="$t('printer.location')">
                        </el-table-column>

                        <el-table-column
                            min-width="40"
                            prop="section.name"
                            :label="$t('printer.section')">
                            <template slot-scope="props">
                                {{ props.row.section ? props.row.section.name : $t('general.all') }}
                            </template>
                        </el-table-column>

                        <el-table-column
                            min-width="40"
                            label="IP">
                            <template slot-scope="props">
                                {{ props.row.ip || '-' }}
                            </template>
                        </el-table-column>

                        <el-table-column
                            min-width="40"
                            :label="$t('settingTable.type')">
                            <template slot-scope="props">
                                {{ getTypeName(props.row.type) }}
                            </template>
                        </el-table-column>

                        <el-table-column
                            min-width="60"
                            :label="$t('printer.correspondingPos')">
                            <template slot-scope="props">
                                <div class="pos-devices-cell" :title="getPosNames(props.row.pos_ids)">
                                    <span class="pos-devices-name">{{ getVisiblePosNames(props.row.pos_ids) }}</span>
                                    <span v-if="getHiddenPosCount(props.row.pos_ids)" class="pos-devices-more">
                                        +{{ getHiddenPosCount(props.row.pos_ids) }}
                                    </span>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            :width="300"
                            :label="$t('marketingOffers.actions')">
                            <template slot-scope="props">
                              <a
                                class="btn delete mar-rt-10"
                                :title="$t('general.delete')"
                                @click="handleDelete(props.row.id)">
                                <img src="/static/img/icons/icon-close.png">
                                {{$t('general.delete')}}
                              </a>
                              <div class="edit" @click="goToRecord(props.row.id)">
                                <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                              </div>
                            </template>
                        </el-table-column>
                    </data-tables>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import PSwitch from 'src/components/UIComponents/Switch.vue'

export default {
  components: {
    // GeneralTopBar,
    PSwitch
  },
  data () {
    return {
      data: [],
      loading: true,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [5, 25, 50]
      },
      pageTopHeight: 0,
      windowHeight: 0,
      posList: [],
      types: [
        {id: 1, name: 'Port Forwarding'},
        {id: 2, name: 'Local'},
        {id: 3, name: 'Label Local'},
        {id: 4, name: 'USB'},
        {id: 5, name: 'Order Label'}
      ]
    }
  },
  created () {
    this.loading = true
    this.loadPosList()
    this.index()

    this.$bus.$on('refresh', this.handleRefresh)
  },
  // mounted () {
  //   this.$bus.$on('refresh', this.handleRefresh)
  // },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    handleRefresh () {
      this.index()
    },
    loadPosList () {
      let sessionData = this.$session.get('selectedCompanyData') || {}
      if (sessionData['compact_pos_list'] && sessionData['compact_pos_list'].length) {
        this.posList = sessionData['compact_pos_list']
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/pos-admin/compact-list', 'GET', data, (response) => {
        if (response.status) {
          this.posList = response.data
          sessionData['compact_pos_list'] = response.data
          this.$session.set('compact_pos_list', response.data)
        }
      })
    },
    getTypeName (typeId) {
      const t = this.types.find(item => item.id === typeId)
      return t ? t.name : '-'
    },
    getPosName (item) {
      const id = (item && typeof item === 'object') ? item.id : item
      const name = (item && typeof item === 'object' && item.name) ? item.name : null
      if (name) {
        return name
      }
      const pos = this.posList.find(p => p.id === id)
      return pos ? pos.name : id
    },
    getVisiblePosNames (posIds) {
      if (!posIds || !posIds.length) {
        return '-'
      }
      return this.getPosName(posIds[0])
    },
    getHiddenPosCount (posIds) {
      if (!posIds || posIds.length <= 1) {
        return 0
      }
      return posIds.length - 1
    },
    getPosNames (posIds) {
      if (!posIds || !posIds.length) {
        return '-'
      }
      const names = posIds.map(item => this.getPosName(item))
      return names.join(', ')
    },
    index () {
      this.loading = true

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/printer', 'GET', data, response => {
        if (response.status) {
          this.data = response.data
        } else {
          swal({
            text: 'Error!',
            type: 'error',
            showConfirmButton: false,
            timer: 1000
          })
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    add () {
      this.$router.push('/printer/add')
    },
    goToRecord (id) {
      this.$router.push('/printer/edit/' + id)
    },
    handleDelete (id) {
      swal({
        title: this.$t('general.generalAreYouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      })
      .then((result) => {
        if (result) {
          this.deletePrinter(id)
        }
      })
    },
    deletePrinter (id) {
      this.loading = true
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      }
      this.apiRequest('/printer/' + id, 'DELETE', data, (response) => {
        if (response.status) {
          this.trackAdminEvent('ADMIN_PRINTER_DELETED', 'printer', id, {
            printer_id: id
          })
          this.index()
          this.loading = false
          swal({
            title: this.$t('general.success'),
            type: 'success'
          })
        } else {
          this.loading = false
          swal({
            title: this.$t('general.error'),
            type: 'error'
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.pos-devices-cell {
  align-items: center;
  display: flex;
  max-width: 100%;
  overflow: hidden;
}

.pos-devices-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pos-devices-more {
  background: #674BD2;
  border-radius: 10px;
  color: #fff;
  flex: 0 0 auto;
  font-size: 11px;
  line-height: 1;
  margin-left: 6px;
  padding: 3px 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Printer/Printers.vue